// @flow
import * as React from 'react';
import styles from './FunctionalLink.less';

type Props = {|
  onClick?: (SyntheticMouseEvent<HTMLAnchorElement>) => mixed,
  href?: string,
  className?: string,
  children: React.Node,
|};

/** An anchor tag which may or may not contain an actual link or even a placeholder link
 * Is functionally similar to a button but is not styled as a button and has all the bells and whistles required for accessibility
 * */
const FunctionalLink = ({ onClick, className = '', href, children }: Props) => (
  <a
    role="button"
    tabIndex={0}
    className={`${styles.cursor} ${className}`}
    href={href}
    onClick={onClick}
  >
    {children}
  </a>
);

export default FunctionalLink;
